module.exports = __webpack_public_path__ + "img/asx_feel.18ed4db0.jpg";